import React from 'react';
import styled from 'styled-components';

export default function InputSwitch({
  checked,
  onChange,
  id = '',
  round = false
}) {
  return (
    <InputSwitchContainer>
      <InputSwitchInput
        type="checkbox"
        id={id}
        checked={checked}
        onChange={onChange}
      />
      <InputSwitchSlider className={round ? 'round' : ''} />
    </InputSwitchContainer>
  );
}

const InputSwitchContainer = styled.label`
  position: relative;
  display: inline-block;
  width: 30px;
  height: 16px;
  margin-bottom: 0;

  @media (min-width: 992px) {
    width: 47px;
    height: 26px;
  }
`;

const InputSwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + .slider {
    background-color: #2196F3;
  }

  &:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
  }
  
  &:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }
`;

const InputSwitchSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #d9d9d9;
  -webkit-transition: .4s;
  transition: .4s;

  &:before {
    position: absolute;
    content: "";
    height: 14px;
    width: 14px;
    left: 1px;
    bottom: 1px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;

    @media (min-width: 992px) {
      width: 24px;
      height: 24px;
    }
  }

  ${InputSwitchInput}:checked + & {
    background-color: #6c6c6c;
  }

  ${InputSwitchInput}:focus + & {
    box-shadow: 0 0 1px #6c6c6c;
  }
  
  ${InputSwitchInput}:checked + &:before {
    -webkit-transform: translateX(14px);
    -ms-transform: translateX(14px);
    transform: translateX(14px);

    @media (min-width: 992px) {
      -webkit-transform: translateX(21px);
      -ms-transform: translateX(21px);
      transform: translateX(21px);
    }
  }

  &.round {
    border-radius: 34px;
  }
  
  &.round:before {
    border-radius: 50%;
  }
`;